import React from 'react';
import Navbar from '../Layout/Navbar/Navbar';
import Footer from '../Layout/Footer/Footer';
import SmallFooter from '../Layout/Footer/FooterInsurance/SmallFooter';

const MainLayout = ({ children, showSmallNavbar }) => {
    return (
        <div className="main-layout">
            {showSmallNavbar ? <Navbar sticky="false" /> : <Navbar sticky="true" />}
            <div className="main-content">
                {children}
            </div>
            {showSmallNavbar ? <SmallFooter /> : <Footer />}
        </div>
    );
};
export default MainLayout;
